// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import {
  bestPerformingArticlesShowAllText,
  defaultFilterText,
} from '@epicuro-next/constants/features/localization';
import { GLOBAL_STORE_PROVIDER_KEY } from '@epicuro-next/data-providers/providers-registry';
import { FiltersChangedEvent } from '@epicuro-next/features/dashboard';
import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import {
  PRODUCTBASKET_FEATURE_KEY,
  State as ProductBasketState,
} from '@epicuro-next/state/p-basket-state';

export type ProductBasketFilter = ProductBasketState['filters'][0];

export function getFilterProperties(
  filtersChangedProvider: IDynamicBindableValue,
  options: { initialCategories: string[]; initialDaysIntoThePast: number },
) {
  return {
    daysIntoThePast: 365,
    categoriesDefaultText: defaultFilterText.categories,
    showAllText: bestPerformingArticlesShowAllText,
    hideFilterWhenNoValues: false,

    initialCategories: options.initialCategories,
    initialDaysIntoThePast: options.initialDaysIntoThePast,
    initialPreselectedPeriod: {
      provider: 'self',
      property: 'initialDaysIntoThePast',
      transform: function (initialDaysIntoThePast: number): {
        from: string;
        to: string;
      } {
        const now = new Date();
        const preselectedDaysIntoThePast = new Date();

        preselectedDaysIntoThePast.setDate(
          preselectedDaysIntoThePast.getDate() - initialDaysIntoThePast,
        );

        const dateRange = {
          from: preselectedDaysIntoThePast.toISOString(),
          to: now.toISOString(),
        };

        return dateRange;
      }.toString(),
    },
    filters: {
      values: [
        filtersChangedProvider,
        { provider: 'self', property: 'initialCategories' },
        { provider: 'self', property: 'initialPreselectedPeriod' },
      ],
      transform: function ([
        filtersChanged,
        initialCategories,
        initialPreselectedPeriod,
      ]: [
        FiltersChangedEvent | undefined | null,
        string[],
        { from: string; to: string },
      ]): FiltersChangedEvent {
        const filters: FiltersChangedEvent = {
          categories: initialCategories,
          dateRange: initialPreselectedPeriod,
        };

        if (filtersChanged !== undefined && filtersChanged !== null) {
          if (filtersChanged.categories !== undefined) {
            filters.categories = filtersChanged.categories;
          }

          if (filtersChanged.dateRange !== undefined) {
            filters.dateRange = filtersChanged.dateRange;
          }
        }

        return filters;
      }.toString(),
    },
  };
}

export function getSearchFiltersProvider(
  ...filterIdsArg: string[]
): IDynamicBindableValue {
  const filterPath: keyof ProductBasketState = 'filters';

  // The following comment is done so a snapshot can be taken from the transform method as a string or else it gets mangled by Instanbul.
  /* istanbul ignore next */
  const transformFunction = function (
    filters: ProductBasketFilter[],
  ): ProductBasketFilter[] {
    const filterFieldIds = JSON.parse(
      String.raw`FILTER_FIELD_IDS_ARRAY_PLACEHOLDER`,
    );
    const filteredFilters = filters.filter((filter) =>
      filterFieldIds.includes(filter.fieldId),
    );
    return filteredFilters;
  };

  const path = `${PRODUCTBASKET_FEATURE_KEY}.${filterPath}`;
  return {
    provider: GLOBAL_STORE_PROVIDER_KEY,
    property: {
      path,
    },
    /* istanbul ignore next */
    transform: transformFunction
      .toString()
      .replace(
        'FILTER_FIELD_IDS_ARRAY_PLACEHOLDER',
        JSON.stringify(filterIdsArg),
      ),
  };
}
